import { generateTestId } from "@client-shared";

const COMPONENT = "AdminProductsView";

export const setAdminProductsViewTestId = (identifier: string): string => generateTestId(COMPONENT, identifier);

export const ADMIN_PRODUCTS_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const ADMIN_PRODUCTS_DEFAULT_PAGE_SIZE = 25;

export const ADMIN_PRODUCTS_PERSISTENCE_KEY = "admin-products-table";
